<template>
  <div class="modal-content">
    <div class="modal-header">
      <button @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
              style="width: 30px; height: 30px; border-radius: 30px; font-size: 30px; background: gray;"><span
              aria-hidden="true">×</span></button>
      <div class="pb-20">
        <div class="pb-30 pt-40 hut-rewards-header">
          <img src="https://static.phdvasia.com/my/fcds/hutawards/hut-reward-black.png">
        </div>
        <h2 class="modal-title title-coupons lg-cond text-center ">{{$t('what_would_you_like')}}</h2>
        <div class="mt-5 fw600">
            <div v-for="(hutRewardItemsObj, i) in hut_rewards" class="pr-20 pl-20 redeem-menu" v-if=" (cart.customer_point != undefined ? cart.customer_point : ($auth.user().point ? $auth.user().point : 0)) - (cart.hut_reward_used? cart.hut_reward_used : 0)   >= hut_rewards[i].point" >
                <div class="hut-reward-body">
                    <div class="fw-700 xs-flex xs-justify-between flex-wrap xs-mb-5 hut-reward-title-item e9ebee cursor-pointer" @click="updateHutRewardItemsShow(hut_rewards[i])">
                        <span class="xs-mb-0">{{$t('hut_reward_redeem_slide',{slide : hut_rewards[i].point})}}</span>
                        <span class="xs-mb-0">
                            <span>
                              <img style="max-width: 20px" src="https://static.phdvasia.com/my/fcds/hutawards/pizza-icon.png">
                            </span>
                            <i class="fa fa-sort-up" v-if="!hut_rewards[i].isCollapse"></i>
                            <i class="fa fa-sort-down" v-if="hut_rewards[i].isCollapse"></i>
                        </span>
                    </div>
                    <collapse v-model="hut_rewards[i].isCollapse">
                        <div class="fw-700 upper redeem-sub-menu" style="font-size: 10px">
                            <div class="redeem-sub-menu-item cursor-pointer" v-for="(hut_reward_item, j) in hut_rewards[i].items" @click="editCombo(hut_reward_item)">
                                <div class="inner t13">
                                    <span>{{hut_reward_item.name}}</span>
                                    <span class="opacity-8" v-if="hut_reward_item.marketing_description">({{hut_reward_item.marketing_description}})
                                    </span>
                                </div>
                            </div>
                        </div>
                    </collapse>
                </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  let vm = null;
  export default {
    mounted () {
      vm = this;
      this.$cart.init(this);
      vm.getHutReward();
    },
    data () {
      return {
        hut_rewards : {},
        hut_reward_items_show : []
      }
    },
    watch: {
    },
    methods: {
      getHutReward () {
        let data = vm.getMenuRequest()
        data.single_type = 1
        data.is_sort = 1

        vm.axios.getHutReward(data, function (response) {
            response.data.data.items.map(item => {
                item.isCollapse= false
            })
          vm.hut_rewards = response.data.data.items;
          this.$forceUpdate(vm.hut_rewards)
        });
      },
      updateHutRewardItemsShow(item) {
          item.isCollapse = !item.isCollapse
      },
      editCombo(menu) {
        vm.$emit('close')
        this.$router.push({name: 'combo-detail', params: {nameseo: menu.friendly_seo_name || '', context: 'reward'}})
      },
    }
  }
</script>

<style scoped>
  .hut-rewards-header {
    max-width: 420px;
    width: 80%;
    margin:0 auto;
  }
  .alert-danger2 {
    color: #a94442;
    font-weight: bold;
  }

  .free-menu-description{
    cursor: pointer;
  }

  .v--modal-box {
    height: auto !important;
    top: 50px !important;
  }
  .modal-coupon .v--modal {
    min-width: 0px !important;
  }

  .e9ebee {
    background-color: #e9ebee;
  }

  .modal-header {
    padding: 15px 0 0;
  }

  .redeem-menu {
      position: relative;
  }
  .redeem-sub-menu {
      padding-top : 1px;
      background-color: white;
  }
    .hut-reward-title-item {
        padding: 10px;
    }
    .hut-reward-body{
        border: 1px solid #e9ebee;
    }
    .redeem-sub-menu-item {
        padding: 15px;
    }
    .redeem-sub-menu-item:hover{
        background: #f4f3f6;
    }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalHutReward.vue